<template>
  <a-modal
    v-model="isVisible"
  >
    <span slot="title">
      <a-icon
        type="info-circle" style="cursor: pointer;" @click="faqVisible = true"></a-icon>
      {{ isNew
        ? 'Создать новую сущность'
        : `Редактировать сущность «${currentEntity}»` }}
    </span>
    <a-form>
      <a-form-item v-if="isNew" class="form-item" label="Системное имя">
        <a-input v-model="name" placeholder="users"></a-input>
      </a-form-item>
      <a-form-item class="form-item" label="Отображаемое имя">
        <a-input v-model="gui" placeholder="Пользователи"></a-input>
      </a-form-item>
    </a-form>
    <template slot="footer">
      <a-button @click="isVisible = false">
        Отменить
      </a-button>
      <a-button v-if="!isNew" type="danger" :loading="isDeleting" @click="remove">
        Удалить
      </a-button>
      <a-button type="primary" :loading="isLoading" @click="save">
        Сохранить
      </a-button>
    </template>
    <a-modal v-model="faqVisible">
      <p><strong>Системное имя сущности</strong> может состоять из a-z0-9.
      Рекомендуем называть сущности в единственном числе, например “comment”, “book”.</p>
      <p><strong>Отображаемое имя может</strong> быть любым по вашему желанию.</p>
      <template slot="footer">
        <a-button @click="faqVisible = false">
          ОК
        </a-button>
      </template>
    </a-modal>
  </a-modal>
</template>

<script>
export default {
  name: 'entity-modal',
  props: ['new'],
  data() {
    return {
      faqVisible: false,
      isDeleting: false,
      isVisible: false,
      isLoading: false,
      name: '',
      gui: '',
    };
  },
  computed: {
    isNew() {
      return typeof this.new !== 'undefined';
    },
  },
  methods: {
    open() {
      this.isVisible = true;
      if (!this.isNew) {
        const entity = this.$store.getters.entities[this.currentEntity];
        this.gui = entity.gui_name || entity.name;
      } else {
        this.gui = '';
        this.name = '';
      }
    },
    save() {
      this.isLoading = true;
      this.$api.defineEntity({
        name: this.isNew ? this.name : this.currentEntity,
        gui: this.gui,
      }).then((response) => {
        this.$store.commit('setEntities', response.data);
        this.isLoading = false;
        this.isVisible = false;
        if (this.isNew) {
          this.$router.push(`/entity/${this.name}`);
        }
      }).catch(() => {
        this.isLoading = false;
      });
    },
    remove() {
      // eslint-disable-next-line
      if (!confirm(`Вы действительно хотите удалить таблицу "${this.currentEntity}"?`)) {
        return;
      }
      this.isDeleting = true;
      this.$api.deleteEntity({
        name: this.currentEntity,
      }).then((response) => {
        this.$store.commit('setEntities', response.data);
        this.isVisible = false;
        this.$router.push(`/entity/${Object.keys(this.$store.getters.entities)[0]}`);
      }).finally(() => {
        this.isDeleting = false;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form-item {
  margin-bottom: 5px;
}

p {
  margin-bottom: 5px;
}

strong {
  font-weight: 700;
}
</style>
